import { backendCode } from '@/api/errors';

/**
 * `409 PAYOUT_METHOD_NOT_CONFIGURED` (H §6.3): the reseller has no agreement yet. Payouts (and an
 * Agreement with no current terms) show the §6.2 empty state `NotPricedState`, "Your reseller
 * agreement isn't set up yet — contact The Money Meeting."
 */
export function isPayoutMethodNotConfigured(err: unknown): boolean {
  return backendCode(err) === 'PAYOUT_METHOD_NOT_CONFIGURED';
}
